(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/result/assets/javascripts/views/result.js') >= 0) return;  svs.modules.push('/modules/lotto/components/result/assets/javascripts/views/result.js');

'use strict';

svs.lotto.components.result.views.Result = Marionette.View.extend({
  viewOptions: ['selectedDate'],
  selectedDate: undefined,
  className: 'ng-game-result-container ng-game-result-container--lotto',
  regions: {
    datePickerRegion: '#datePickerRegion',
    lotto1ResultRowRegion: '#lotto1ResultRowRegion',
    lotto1PayoutRegion: '#lotto1PayoutRegion',
    peppbubblesRegion: '#peppbubblesRegion',
    lotto2ResultRowRegion: '#lotto2ResultRowRegion',
    lotto2PayoutRegion: '#lotto2PayoutRegion',
    jokerResultRowRegion: '#jokerResultRowRegion',
    jokerPayoutRegion: '#jokerPayoutRegion',
    andraChansenWinnerRegion: '#andraChansenWinnerRegion'
  },
  modelEvents: {
    'results:change:draw': 'renderResult'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.results.behaviors.BindResultModel,
    resultData: svs.lotto.data.resultData,
    jackpot: svs.lotto.data.jackpots,
    product: svs.numbergames.productMapping.CONSTANTS.LOTTO
  }],
  template(data) {
    return svs.lotto.components.result.templates.result(data);
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    this.showChildView('datePickerRegion', new svs.numbergames.results.views.DatePicker({
      model: this.model
    }));
    const draw = this.model.get('resultMonths').getDrawByDate(this.model.get('selectedDate'));
    const resultModel = draw ? this.model.get('results').getResultByDraw(draw) : this.model.get('results').first();
    if (resultModel) {
      this.renderResult(resultModel);
    }
    this.showChildView('andraChansenWinnerRegion', new svs.lotto.components.result.views.AndraChansenWinner({
      model: this.model
    }));
  },
  renderResult(model) {
    const lotto1Model = model.get('lotto1');
    this.showChildView('lotto1ResultRowRegion', new svs.numbergames.results.views.CorrectRow({
      model: lotto1Model
    }));
    this.showChildView('lotto1PayoutRegion', new svs.numbergames.results.views.PayoutTable({
      model: lotto1Model.get('payout')
    }));
    this.showChildView('peppbubblesRegion', new svs.numbergames.results.views.Peppbubbles({
      model
    }));
    const lotto2Model = model.get('lotto2');
    this.showChildView('lotto2ResultRowRegion', new svs.numbergames.results.views.CorrectRow({
      model: lotto2Model
    }));
    this.showChildView('lotto2PayoutRegion', new svs.numbergames.results.views.PayoutTable({
      model: lotto2Model.get('payout')
    }));
    const jokerModel = model.get('joker');
    this.showChildView('jokerResultRowRegion', new svs.numbergames.results.views.CorrectRow({
      model: jokerModel
    }));
    this.showChildView('jokerPayoutRegion', new svs.numbergames.results.views.PayoutTable({
      model: jokerModel.get('payout')
    }));
  }
});

 })(window);